import React, { useContext, useState } from 'react'
import { useRouter } from 'next/router'
import find from 'lodash/find'
import './languageSwitch.scss'
import GlobalContext from '../../global'

function LanguageSwitch() {
  const router = useRouter()
  const [open, changeOpen] = useState(false)
  const global = useContext(GlobalContext)
  // dont show language switch if its not necessary
  if (global.data.enabled_languages.length < 2) {
    return null
  }
  const currentLanguageHuman = find(global.data.enabled_languages, ['language_code', router.query.lang.toLowerCase()])
    .language_human
  // when a language is clicked, simply redirect to that url
  const onLanguageSelect = lang => {
    const url = global.pageAlternateLanguages.find(pal => pal.lang === lang).url
    window.location.href = url
  }
  return (
    <div className="language-switch">
      <div className="language-display" onClick={() => changeOpen(!open)}>
        <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <path
            fill="#FFF"
            fillRule="evenodd"
            d="M20,10.0002 C20,4.4862 15.514,0.0002 10,0.0002 C4.486,0.0002 0,4.4862 0,10.0002 C0,15.5142 4.485,19.9992 9.999,20.0002 L10,20.0002 C15.514,20.0002 20,15.5142 20,10.0002 Z M0.699,10.3412 L3.916,10.3412 C3.977,11.7722 4.331,13.1742 4.944,14.4892 L1.839,14.4892 C1.155,13.2512 0.753,11.8402 0.699,10.3412 Z M1.839,5.5112 L4.855,5.5112 C4.264,6.8142 3.94,8.2122 3.908,9.6592 L0.699,9.6592 C0.753,8.1602 1.155,6.7492 1.839,5.5112 Z M19.301,9.6592 L16.091,9.6592 C16.059,8.2122 15.734,6.8142 15.144,5.5112 L18.161,5.5112 C18.845,6.7492 19.247,8.1602 19.301,9.6592 Z M15.409,9.6592 L10.341,9.6592 L10.341,5.5112 L14.387,5.5112 C15.022,6.8072 15.375,8.2072 15.409,9.6592 Z M10.341,4.8292 L10.341,0.9712 C11.915,2.0412 13.159,3.3562 14.022,4.8292 L10.341,4.8292 Z M9.659,4.8292 L5.977,4.8292 C6.84,3.3552 8.084,2.0402 9.659,0.9702 L9.659,4.8292 Z M9.659,5.5112 L9.659,9.6592 L4.589,9.6592 C4.624,8.2072 4.977,6.8072 5.612,5.5112 L9.659,5.5112 Z M4.597,10.3412 L9.659,10.3412 L9.659,14.4892 L5.672,14.4892 C5.025,13.1902 4.659,11.7902 4.597,10.3412 Z M9.659,15.1702 L9.659,19.0152 C8.123,17.9332 6.901,16.6262 6.042,15.1702 L9.659,15.1702 Z M10.341,15.1702 L13.957,15.1702 C13.098,16.6262 11.876,17.9332 10.341,19.0152 L10.341,15.1702 Z M10.341,14.4892 L10.341,10.3412 L15.402,10.3412 C15.34,11.7902 14.973,13.1902 14.327,14.4892 L10.341,14.4892 Z M16.083,10.3412 L19.301,10.3412 C19.247,11.8402 18.845,13.2512 18.161,14.4892 L15.056,14.4892 C15.668,13.1742 16.022,11.7732 16.083,10.3412 Z M17.747,4.8292 L14.805,4.8292 C13.979,3.2962 12.771,1.9172 11.234,0.7732 C13.944,1.1342 16.291,2.6562 17.747,4.8292 Z M8.765,0.7732 C7.228,1.9172 6.02,3.2962 5.194,4.8292 L2.253,4.8292 C3.709,2.6562 6.055,1.1342 8.765,0.7732 Z M2.253,15.1702 L5.288,15.1702 C6.125,16.6992 7.319,18.0862 8.813,19.2342 C6.083,18.8852 3.717,17.3572 2.253,15.1702 Z M11.186,19.2342 C12.68,18.0862 13.874,16.6992 14.711,15.1702 L17.747,15.1702 C16.282,17.3572 13.916,18.8852 11.186,19.2342 Z"
          />
        </svg>
        <div className="text">{currentLanguageHuman}</div>
        <svg className="chevron" viewBox="0 0 10 5" height="5" width="10">
          <polygon fill="#fff" points="0,0 10,0 5,5" />
        </svg>
      </div>
      <div className={`language-dropdown ${open ? 'visible' : 'invisible'}`}>
        {global.data.enabled_languages.map(lang => {
          const isFound = !!global.pageAlternateLanguages.find(pal => pal.lang === lang.language_code)
          // don't show the current language, only alternate ones
          if (!isFound) {
            return null
          }
          return (
            <div
              key={`language-${lang.language_code}`}
              className="language"
              onClick={() => onLanguageSelect(lang.language_code)}
            >
              {lang.language_human}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default LanguageSwitch
